/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const Context = /*#__PURE__*/React.createContext(null);
export default class Theme extends React.Component {
  static get I18N() {
    return window.uiElementsI18N;
  }
  static set I18N(i18n) {
    if (typeof i18n.t !== 'function') {
      console.error('setI18N expects a t function');
      return;
    }
    if (typeof i18n.tIcon !== 'function') {
      console.error('setI18N expects a tIcon function');
      return;
    }
    if (typeof i18n.ns !== 'function') {
      console.error('setI18N expects a ns function');
      return;
    }
    window.uiElementsI18N = i18n;
  }
  constructor(props) {
    super(props);
    this.state = {
      theme: null
    };
  }
  componentDidMount() {
    const {
      theme
    } = this.props;
    if (theme && typeof theme.setOnChange === 'function') {
      // this is a theme that is managing change. Set the state theme
      theme.setOnChange(this.onChange);
    }
  }
  onChange = newTheme => {
    this.setState({
      theme: newTheme
    });
  };
  render() {
    if (!this.props.children) {
      return null;
    }
    return /*#__PURE__*/_jsx(Context.Provider, {
      value: this.state.theme || this.props.theme,
      children: this.props.children
    });
  }
}
Theme.Context = Context;
import('@leverege/i18n').then(({
  default: I18N
}) => {
  Theme.I18N = I18N.ns('ui-elements');
}).catch(error => {
  // do nothing
});
const defaultI18N = {
  t: (dud, opts, value) => typeof opts === 'string' ? opts : value || dud,
  tIcon: (dud, value) => value || dud,
  ns: () => window.uiElementsI18N
};
Theme.I18N = defaultI18N;